import React, { useState, useEffect } from 'react';
import { Label } from 'atoms/Texts';
import { FormOtp } from 'atoms/Inputs';
import { ButtonReg } from 'atoms/Buttons';
import { 
  OtpRow, 
  BtnRow, 
  StyledOtpImg, 
  ContainerTxt, 
  SpanLink ,
  ContainerError
} from './styles';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';

const otpImg = require('App/assets/images/otp.png');

const VerificationForm = (props) => {
  const {
    valEmail = 'test@gmail.com',
    countDownTime = '2',
    valVerification,
    fnVerificationOnChange,
    fnVerificationOnSubmit,
    fnVerificationResendCode
  } = props;

  const [timeLeft, setTimeLeft] = useState(parseInt(countDownTime) * 60);
  const [isErrorSubmit, setIsErrorSubmit] = useState(false);

  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  useEffect(() => {
    setTimeLeft(parseInt(countDownTime) * 60)
  }, [countDownTime])

  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
  };

  const censoredEmail = (email) => {
    if (email) {
      const wordCensor = (value) => {
        if (value.length <= 2) return value;
        return value[0] + '*'.repeat(value.length - 2) + value.slice(-1);
      };
  
      const [localPart, domainPart] = email.split('@');
      if (!localPart || !domainPart) return email;
  
      return `${wordCensor(localPart)}@${wordCensor(domainPart)}`;
    }
  
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsErrorSubmit(false)
    if (valVerification.length < 6) {
      setIsErrorSubmit(true)
      return;
    }

    fnVerificationOnSubmit()
  }

  const handleResend = () => {
    setIsErrorSubmit(false);
    fnVerificationResendCode()
  }

  return (
    <div>
      <form onSubmit={fnVerificationOnSubmit}>
        <StyledOtpImg
          src={otpImg}
          alt={'img-otp'}
          {...props}
        />
        <Label size={'14px'} weight={'normal'} mb={'0px'} mt={'30px'} textAlign={'center'}>
          For added security, you will need to verify your identity. We have sent a verification code to:
        </Label>
        <ContainerTxt>
          <Label size={'18px'} mb={'16px'} mt={'16px'} weight={'normal'} textAlign={'center'}>
            {censoredEmail(valEmail)}
          </Label>
        </ContainerTxt>
        {
          isErrorSubmit && (
            <ContainerError>
              <Label color={'#721c24'} size={'14px'} mb={'16px'} mt={'16px'} weight={'normal'} textAlign={'center'}>
                Please enter all OTP digits in the fields below
              </Label>
            </ContainerError>
          )
        }
        {props.isErrLogin &&
          <ContainerError>
            <Label color={'#721c24'} size={'14px'} mb={'16px'} mt={'16px'} weight={'normal'} textAlign={'center'}>
              {props.isErrMsg}
            </Label>
          </ContainerError>
        }
        <ContainerTxt>
          <Label color={'red'} size={'16px'} mb={'0px'} textAlign={'center'}>
            {formatTime(timeLeft)}
          </Label>
        </ContainerTxt>
        <ContainerTxt>
          <Label size={'14px'} weight={'normal'} mb={'16px'} mt={'16px'} textAlign={'center'}>
            Please enter received code below
          </Label>
        </ContainerTxt>
        <OtpRow>
          <FormOtp
            value={valVerification}
            onChangeVal={fnVerificationOnChange}
            numInputs={6}
            isInputNum={true}
            shouldAutoFocus={true}
          />
        </OtpRow>
        <BtnRow>
          <ButtonReg
            width={'100%'}
            btnTxt={'Verify Code'}
            onClick={handleSubmit}
            btnType={'submit'}
            disabled={timeLeft <= 0}
          />
        </BtnRow>
        <ContainerTxt>
          <Label size={'14px'} weight={'normal'} mb={'0px'} mt={'16px'} textAlign={'center'}>
          It may take a minute to receive your code
          </Label>
        </ContainerTxt>
        <ContainerTxt>
          <Label size={'14px'} weight={'normal'} mb={'0px'} mt={'0px'} textAlign={'center'}>
            Haven't received it? <SpanLink onClick={handleResend}>Resend a new code</SpanLink>
          </Label>
        </ContainerTxt>
      </form>
    </div>
  );
};

export default withRouter(withTheme(VerificationForm));
